import React, {FC} from 'react';
import './style.scss';
import AddTastesButton from "../AddTastesButton";

interface IItemMixerNow {
    brandName: string,
    tobaccoName: string,
    onClick: () => void
}

const ItemMixerNow: FC<IItemMixerNow> = ({
                                             brandName,
                                             tobaccoName,
                                             onClick
                                         }) => {
    return (
        <div className="item-mixer-now">
            <div className="item-mixer-now__info">
                <div className="item-mixer-now__tobacco">
                    {tobaccoName}
                </div>
                <div className="item-mixer-now__brand">
                    {brandName}
                </div>
            </div>
            <div
                className="item-mixer-now__button"
                onClick={onClick}
            >
                <AddTastesButton
                    isActive={true}
                />
            </div>
        </div>
    )
};

export default ItemMixerNow;
